import { Component } from '@verndale/core'
import Swiper, { Pagination } from 'swiper'
import { MEDIA_QUERIES } from '../utils'

class NewsRow extends Component {
  setupDefaults() {
    this.dom = {
      sliderContainer: this.el.querySelector('.swiper')
    }
    this.tablet = window.matchMedia(`(min-width: ${MEDIA_QUERIES.TABLET_LANDSCAPE}px)`)
    this.initSlider()
  }

  addListeners() {
    this.tablet.onchange = (e) => {
      if (!e.matches) {
        this.initSlider()
      }
    }
  }

  initSlider() {
    if (!this.tablet.matches) {
      const swiper = new Swiper(this.dom.sliderContainer, {
        modules: [Pagination],
        simulateTouch: true,
        draggable: true,
        breakpoints: {
          [MEDIA_QUERIES.MOBILE]: {
            slidesPerView: 1.5,
            spaceBetween: 10,
            centeredSlides: true
          },
          [MEDIA_QUERIES.TABLET]: {
            spaceBetween: 10,
            slidesPerView: 3,
            centeredSlides: true
          },
          [MEDIA_QUERIES.TABLET_LANDSCAPE]: {
            spaceBetween: 10,
            slidesPerView: 3
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets'
        },
        on: {
          resize: () => {
            if (this.tablet.matches) {
              swiper.destroy()
            }
          }
        }
      })
    }
  }
}

export default NewsRow
